import { Component, OnInit } from "@angular/core";
import { AuthService } from "../shared/auth/auth.service";
import { Router } from "@angular/router";
import { NgForm } from "@angular/forms";
import { Logging } from "../logging";
import { ApiService } from "../shared/api-service/api.service";
import { HelpersService } from "../shared/helpers/helpers.service";

declare var jquery: any;
declare var $: any;
declare var App: any;

@Component({
  selector: "app-login-verification",
  templateUrl: "./login-verification.component.html",
  styleUrls: ["./login-verification.component.css"],
})
export class LoginVerificationComponent implements OnInit {
  constructor(
    private api: ApiService,
    private auth: AuthService,
    private router: Router,
    private helpers: HelpersService
  ) {}

  loading: Boolean = false;
  hasError: Boolean = false;
  errorMessage: string;
  userName: string;
  emailCodeError: string;
  mobileCodeError: string;
  showForceLogoutError: any = false;
  loginDetails: any;
  sendingPhoneCode: any;
  sendingEmailCode: any;
  phoneCodeSent: any;
  emailCodeSent: any;
  staffLoginDetails: any;

  userDetails: any;

  ngOnInit() {
    if (!this.auth.loginDetailsSet()) {
      this.router.navigate(["/login"]);
    }

    this.loginDetails = this.auth.getLoginDetails();
    this.userName = this.loginDetails.name;

    Logging.log(this.loginDetails);

    if (
      this.loginDetails.accountlocked == true &&
      this.loginDetails.emailvalidated == true &&
      this.loginDetails.phonevalidated == true
    ) {
      this.router.navigate(["/login/account-locked"]);
      return true;
    } else if (
      this.loginDetails.emailvalidated == true &&
      this.loginDetails.phonevalidated == true
    ) {
      this.router.navigate(["/login/verify-password"]);
      return true;
    }
  }

  validateAccount(form: NgForm) {
    var self = this;

    //Set loading to true to show loader
    this.loading = true;
    this.hasError = false;

    // Collect form values
    const values = form.value;

    if (!this.loginDetails.emailvalidated) {
      const email_payload = {
        email: this.loginDetails.email,
        emailcode: values.email_code,
      };

      //Make the api request
      this.api.post("/users/validateemail", email_payload).subscribe(
        (res_data) => {
          Logging.log(res_data);

          //Set the login details for the current user.
          Logging.log(this.auth.getLoginDetails());
          //Redirect if condition is met
          this.resetLoginDetailsAndRedirect(this.loginDetails.email);

          this.loading = false;
        },
        (error_message) => {
          this.loading = false;
          this.hasError = true;
          this.errorMessage = error_message;
        }
      );
    }

    if (!this.loginDetails.phonevalidated) {
      const phone_payload = {
        userid: this.loginDetails.userid,
        phonecode: values.mobile_code,
      };

      //Make the api request
      this.api.post("/users/validatephone", phone_payload).subscribe(
        (res_data) => {
          Logging.log(res_data);

          //Set the login details for the current user.
          Logging.log(this.auth.getLoginDetails());

          //Redirect if condition is met
          this.resetLoginDetailsAndRedirect(this.loginDetails.email);

          this.loading = false;
        },
        (error_message) => {
          this.loading = false;
          this.hasError = true;
          this.errorMessage = error_message;
        }
      );
    }
  }

  resendUserPhoneCode() {
    this.sendingPhoneCode = true;
    var self = this;

    var payload = {
      userid: this.loginDetails.userid,
    };

    //Make the api request
    this.api.post("/users/resendphonecode", payload).subscribe(
      (res_data) => {
        Logging.log(res_data);

        this.loading = false;
        this.sendingPhoneCode = false;
        this.phoneCodeSent = true;
      },
      (error_message) => {
        this.loading = false;
        this.hasError = true;
        this.sendingPhoneCode = false;
        this.phoneCodeSent = false;
        this.errorMessage = error_message;
      }
    );
  }

  resendUserEmailCode() {
    this.sendingEmailCode = true;
    var self = this;

    var payload = {
      userid: this.loginDetails.userid,
    };

    //Make the api request
    this.api.post("/users/resendemailcode", payload).subscribe(
      (res_data) => {
        Logging.log(res_data);

        this.loading = false;
        this.sendingEmailCode = false;
        this.emailCodeSent = true;
      },
      (error_message) => {
        this.loading = false;
        this.hasError = true;
        this.sendingEmailCode = false;
        this.phoneCodeSent = false;
        this.errorMessage = error_message;
      }
    );
  }

  resetLoginDetailsAndRedirect(email_address: any) {
    var self = this;
    const validationstatus = {
      email: email_address,
    };

    //Make the api request
    this.api.post("/users/validationstatus", validationstatus).subscribe(
      (res_data) => {
        Logging.log(res_data);

        //Set the login details for the current detail.
        this.auth.loginDetails_set.subscribe((status) => {
          if (status == true) {
            this.loginDetails = this.auth.getLoginDetails();
            this.staffLoginDetails = this.auth.getStaffLoginDetails();

            Logging.log("Reset Reset Reset");
          }
        });

        //Set the login details for the current user.
        this.userDetails = res_data.data[0];
        this.userDetails.email = email_address;
        this.auth.setLoginDetails(this.userDetails);

        //Redirect if condition is met
        if (
          res_data.data[0].phonevalidated == true &&
          res_data.data[0].emailvalidated == true
        ) {
          var animationOut = "animated fadeOutLeft";
          var animationend =
            "wenkitAnimationEnd mozAnimationEnd MS AnimationEnd oanimationend animationend";

          //Show The next form depending on user data
          $("#credentials-verification")
            .addClass(animationOut)
            .one(animationend, function () {
              self.router.navigate(["/login/verify-password"]);
            });
        }
      },
      (error_message) => {
        this.loading = false;
        this.hasError = true;
        this.errorMessage = error_message;
      }
    );
  }

  clearErrors() {
    this.hasError = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/login-verification/login-verification.component.ts